<template>
	<div
		@click="handleProductClick"
		class="category-item product-item"
	>
		<img
			:src="product.image_url"
			:alt="product.title"
			class="category-item__img img-responsive"
			loading="lazy"
		/>
		<div class="category-item__overlay">
			<h5
				v-html="product.title"
				class="category-item__title"
			></h5>
		</div>
	</div>
</template>


<script>
	export default {
		name: 'ProductBlock',
		props: {
			product: {
				type: Object,
				required: true
			},
		},

		data() {
			return {
				isLoading: false
			}
		},

		methods: {
			handleProductClick() {
				this.$emit( 'handle_product_click' )
			}
		}
	}
</script>